import React from 'react';
import MarketingNav from '../components/layout/MarketingNav';
import MarketingFooter from '../components/layout/MarketingFooter';
import Section from '../components/common/Section';
import SectionHeader from '../components/common/SectionHeader';
import Badge from '../components/ui/Badge';

const HipaaNoticePage = () => {
  return (
    <div className="min-h-screen">
      <MarketingNav transparent={false} />

      <main>
        <Section background="light" padding="xl">
          <div className="max-w-3xl">
            <Badge variant="primary" className="mb-4">HIPAA Notice</Badge>
            <h1 className="text-4xl md:text-6xl font-extrabold mb-6">Notice of Privacy Practices</h1>
            <p className="text-lg md:text-xl text-text-muted">
              This notice describes how protected health information may be used and disclosed.
            </p>
            <p className="mt-4 text-sm text-neutral-500">Last updated: February 4, 2026</p>
          </div>
        </Section>

        <Section background="white" padding="lg">
          <SectionHeader
            badge="Your Rights"
            title="How we handle health information"
            subtitle="We follow HIPAA-aligned practices to safeguard sensitive data."
            alignment="left"
          />

          <div className="mt-8 space-y-6 text-sm text-neutral-700">
            <div>
              <h3 className="text-base font-semibold text-neutral-900">Permitted uses</h3>
              <p className="mt-2 text-neutral-600">
                We use information to provide the program, support clinical collaboration (with consent), and maintain security.
              </p>
            </div>
            <div>
              <h3 className="text-base font-semibold text-neutral-900">Your rights</h3>
              <ul className="mt-2 list-disc space-y-2 pl-5">
                <li>Request access to your records.</li>
                <li>Request corrections to your information.</li>
                <li>Request restrictions on sharing with clinicians.</li>
                <li>Request an account of disclosures.</li>
              </ul>
            </div>
            <div>
              <h3 className="text-base font-semibold text-neutral-900">Safeguards</h3>
              <p className="mt-2 text-neutral-600">
                We apply encryption, access controls, monitoring, and secure infrastructure to protect your data.
              </p>
            </div>
            <div>
              <h3 className="text-base font-semibold text-neutral-900">Questions or complaints</h3>
              <p className="mt-2 text-neutral-600">
                Contact support@mhdfmomentum.com with HIPAA questions or concerns.
              </p>
            </div>
          </div>
        </Section>
      </main>

      <MarketingFooter />
    </div>
  );
};

export default HipaaNoticePage;
